import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from '../pages/Home'
import Login from '../pages/Login'
import Upload from '../pages/Upload'
import Store from '../pages/Store'
import Library from '../pages/Library'
import GlobalLibrary from '../pages/GlobalLibrary'
import ImageInfo from '../pages/ImageInfo'
import EditImage from '../pages/EditImage'

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/logga-in" element={<Login />} />
        <Route path="/:storeId" element={<Store />} />
        <Route path="/:storeId/global" element={<GlobalLibrary />} />
        <Route path="/:storeId/:channelType/ladda-upp" element={<Upload />} />
        <Route path="/:storeId/:channelType/:id" element={<ImageInfo />} />
        <Route path="/:storeId/:channelType/:id/redigera" element={<EditImage />} />
        <Route path="/:storeId/:channelType" element={<Library />} />
      </Routes>
    </Router>
  )
}

export default AppRoutes
